import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Collegamento } from 'src/app/models/collegamento';
import { CollegamentoService } from 'src/app/services/collegamento.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditCollegamentoComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'collegamenti',
  templateUrl: './collegamenti.component.html',
  styleUrls: ['./collegamenti.component.scss']
})
export class CollegamentiComponent implements OnInit {


  headingText: string = 'Collegamenti';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'URL',
        internalName: 'url',
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Ordinale',
        internalName: 'ordinale',
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Compagnia',
        internalName: 'compagnia_id',
        displayFunction: route => route?.compagnia?.nome
      }
    ),
  ];
  constructor(public collegamentoService: CollegamentoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<CollegamentiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona uno collegamento';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (collegamento: Collegamento) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare lo collegamento ${collegamento.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.collegamentoService.delete(collegamento);
          this.toast.success('Collegamento eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione collegamento fallita.", "Errore!");
    }
  }



  editFunction = async (collegamento: Collegamento) => {
    try {
      let dialogRef = this.dialog.open(EditCollegamentoComponent, { data: collegamento });
      dialogRef.afterClosed().subscribe(async (data: Collegamento) => {
        if (data) {
          Object.assign(collegamento, { ...data, compagnia_id: data?.compagnia?.id});

          await this.collegamentoService.edit(collegamento);

          this.toast.success('Collegamento modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica collegamento fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditCollegamentoComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(collegamento?: Collegamento) {
    console.log('asd', collegamento)
    if (collegamento) {
      try {
        await this.collegamentoService.create(collegamento)
        this.toast.success('Collegamento creato!')
      }
      catch (e) {
        this.toast.error('Creazione collegamento fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
